import { render, staticRenderFns } from "./AssetsDashboard.vue?vue&type=template&id=3d296576&scoped=true&"
import script from "./AssetsDashboard.vue?vue&type=script&lang=js&"
export * from "./AssetsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d296576",
  null
  
)

export default component.exports